import React from "react";
import { Link, useLocation } from "react-router-dom";

export default function MainLayout({ children }) {
  const { pathname } = useLocation();

  const isPolicyPage =
    pathname === "/privacy" ||
    pathname === "/complaints" ||
    pathname === "/terms" ||
    pathname === "/resources";

  return (
    <div className="min-h-screen flex flex-col bg-white font-body">
      <a
        href="#main"
        className="sr-only focus:not-sr-only focus:absolute focus:top-2 focus:left-2 bg-white px-3 py-2 rounded shadow"
      >
        Skip to content
      </a>

      <main
        id="main"
        className={`flex-1 ${isPolicyPage ? "print:pt-0" : ""}`}
        style={{ paddingTop: "var(--app-header-h, 4rem)" }}
      >
        {/* Reserve space for the fixed bottom consent banner so it won't cover content */}
        <div className="pb-28 sm:pb-24">{children}</div>
      </main>

      <footer className="border-t border-gray-200 print:hidden">
        <div className="max-w-7xl mx-auto px-4 py-6 flex flex-col sm:flex-row sm:justify-between sm:items-center gap-3 text-sm text-gray-500">
          <div className="leading-relaxed">© {new Date().getFullYear()} XLZ Real Estate Pty Ltd</div>

          <nav aria-label="Footer links" className="flex flex-wrap gap-x-4 gap-y-2">
            <Link to="/privacy" rel="nofollow" className="hover:underline hover:text-xlzteal">
              Privacy
            </Link>
            <Link to="/complaints" rel="nofollow" className="hover:underline hover:text-xlzteal">
              Complaints
            </Link>
            <Link to="/terms" rel="nofollow" className="hover:underline hover:text-xlzteal">
              Terms
            </Link>
            <Link to="/resources" rel="nofollow" className="hover:underline hover:text-xlzteal">
              Insights &amp; Resources
            </Link>
          </nav>
        </div>
      </footer>
    </div>
  );
}
